import axios from 'axios'
import { getSoundEffectUrl as getCreatureSoundEffectUrl } from './config/audio/creature'
import { getSoundEffectUrl as getAbilitySoundEffectUrl } from './config/audio/ability'
import { getSoundEffectUrl as getSpellSoundEffectUrl } from './config/audio/spell'
import store from '@/store'

const ossURL = process.env.VUE_APP_OSS_URL

const CancelToken = axios.CancelToken

const audioCtx = new (window.AudioContext || window.webkitAudioContext)()

const gainNode = audioCtx.createGain()
gainNode.connect(audioCtx.destination)
// const defaultVal = gainNode.gain.defaultValue
gainNode.gain.value = +localStorage.getItem('h3_volume') || 0

const audioBufferCache = {}
const bufferSourceCache = {}

function noop () {
  return false
}

function changeVolume (value) {
  gainNode.gain.setValueAtTime(value, audioCtx.currentTime)
}

function getAudioBuffer (audioURL, cancelTokenCallback) {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'get',
      url: audioURL,
      responseType: 'blob'
    }
    if (cancelTokenCallback) {
      options.cancelToken = new CancelToken((c) => {
        cancelTokenCallback(c)
      })
    }
    axios(options)
      .then(blob => {
        const reader = new FileReader()
        let blobFile = blob
        if (!(blob instanceof Blob)) {
          blobFile = blob.data
        }
        reader.readAsArrayBuffer(blobFile)
        reader.onload = function () {
          audioBufferCache[audioURL] = reader.result
          resolve(reader.result)
        }

        reader.onerror = reject
      })
      .catch(reject)
  })
}

function stopAll () {
  for (let id in bufferSourceCache) {
    if (bufferSourceCache.hasOwnProperty(id)) {
      stop(id)
    }
  }
}

function stop (id) {
  if (!id) {
    return
  }
  id = wrapperUrl(id)
  if (!bufferSourceCache[id]) {
    return
  }
  const { bufferSource, cancelToken } = bufferSourceCache[id]
  if (cancelToken) {
    cancelToken()
    // console.log('>>>>>> [cancelToken]', id, Date.now())
  }
  bufferSourceCache[id].cancelToken = null
  if (bufferSource) {
    bufferSource.stop(0)
  }
  bufferSourceCache[id].stopped = true
}

function wrapperUrl (url = '') {
  // return url.replace(/^https:/, 'http:').replace(/^\/\//, 'http://')
  return url.replace(/^http:/, 'https:').replace(/^\/\//, 'https://')
}

function play ({ url, abilityCode, spellCode, creatureName, type, loop = false, playbackRate = 1 }, onended) {
  let audioUrl
  if (url) {
    audioUrl = url.replace(/\/\/\d+\.\d+\.\d+\.\d+:\d+/, ossURL).replace('//yxwd.top', ossURL)
  } else if (abilityCode) {
    audioUrl = getAbilitySoundEffectUrl(abilityCode)
  } else if (spellCode) {
    audioUrl = getSpellSoundEffectUrl(spellCode)
  } else if (creatureName) {
    audioUrl = getCreatureSoundEffectUrl(creatureName, type)
  }

  if (!audioUrl) {
    console.error('empty audioUrl')
    onended && onended()
    return
  }

  audioUrl = wrapperUrl(audioUrl)

  // if (bufferSourceCache[audioUrl] && !bufferSourceCache[audioUrl].stopped) {
  //   return
  // }

  bufferSourceCache[audioUrl] = {
    stopped: false,
    bufferSource: null
  }

  if (store.getters['device/isAppleDevice']) {
    audioCtx.resume()
  }
  getAudioBuffer(audioUrl, (cancelToken) => {
    const lastCancelToken = bufferSourceCache[audioUrl].cancelToken
    if (lastCancelToken) {
      lastCancelToken()
    }
    bufferSourceCache[audioUrl].cancelToken = cancelToken
  })
    .then(buffer => {
      audioCtx.decodeAudioData(
        buffer,
        function (buffer) {
          const bs = audioCtx.createBufferSource()

          bs.connect(gainNode)
          bs.buffer = buffer
          bs.playbackRate.value = playbackRate
          bs.connect(audioCtx.destination)
          bs.loop = !!loop
          bs.onended = () => {
            bufferSourceCache[audioUrl].cancelToken = null
            ;(onended || noop)()
          }
          bufferSourceCache[audioUrl].bufferSource = bs
          if (!bufferSourceCache[audioUrl].stopped) {
            bs.start()
          }
        },
        function (err) {
          console.error('Error:', err, url, abilityCode, spellCode, creatureName, type)
        })
    })
    .catch((err) => {
      console.error('[play]', err)
      onended && onended()
    })

  return audioUrl
}

export default { play, stop, stopAll, changeVolume }

window.audioCtrl = { play, stop, stopAll, changeVolume }
